export default __webpack_public_path__ + "static/media/Princess2.1bdfd652.jpg";